import { Search } from "lucide-react";
import { EmptyState } from "@/components/common/EmptyState";

export function BlankSearchState() {
  return (
    <EmptyState
      icon={Search}
      title="Find your perfect teacher"
      description="Search by subject, exam, or curriculum to get started."
      iconBgClassName="bg-sky-50"
      iconClassName="text-sky-500"
    />
  );
}
